/** @format */

import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { useStyles } from '../Style';
const SimpleDialog = (props) => {
  const { onClose, selectedValue, open } = props;
  const classes = useStyles();

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      fullWidth
      maxWidth="xl"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">جزئیات سرویس</DialogTitle>
      <DialogContent className={classes.dialog}>
        <div>
          <pre>{selectedValue}</pre>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          بستن
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SimpleDialog;
